import React from "react";
import PropTypes from "prop-types";
import {Label} from "semantic-ui-react";

const User = ({
                  user,
              }) => {
    const hasPhoto = !!user.photoURL;
    return <Label size="mini" basic image={hasPhoto}>
        {hasPhoto && <img src={user.photoURL} alt="" />}
        {user.displayName}
    </Label>;
};

User.propTypes = {
    user: PropTypes.object.isRequired,
};

export default User;


// WEBPACK FOOTER //
// ./src/util/User.js